export default __webpack_public_path__ + "static/media/FABLogo.a7748998.png";